import { Button, Stack } from "@mui/material";
import { useStore } from "@tanstack/react-form";
import type React from "react";
import { useMemo } from "react";
import type { OverviewForm } from "../../../hooks/useOverview.ts";
import type { useHomeFilter } from "../../../hooks/useHomeFilter.ts";

interface ActiveFiltersProps {
  overviewForm: OverviewForm;
  homeFilter: ReturnType<typeof useHomeFilter>;
  onClickFiltrovat: () => void;
  onClickReset: () => void;
}

interface ActiveFilterItemProp {
  filterKey:
    | "AssetsCategoryId"
    | "RegionId"
    | "Price"
    | "DetailCategoryFilter.NajetoDo"
    | "DetailCategoryFilter.Palivo"
    | "DetailCategoryFilter.Prevodovka"
    // | "DetailCategoryFilter.RokVyrobyOd"
    // | "DetailCategoryFilter.RokVyrobyDo"
    | "DetailCategoryFilter.RokUvedeniDoProvozuOd"
    | "DetailCategoryFilter.RokUvedeniDoProvozuDo"
    | "DetailCategoryFilter.Znacka";
}

interface ActiveFiltersArrayProps extends ActiveFilterItemProp {
  value: string | number | undefined;
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  overviewForm,
  onClickFiltrovat,
  onClickReset,
}) => {
  const AssetsCategoryId = useStore(
    overviewForm.store,
    (select) => select.values.AssetsCategoryId,
  );
  const RegionId = useStore(
    overviewForm.store,
    (select) => select.values.RegionId,
  );
  const Price = useStore(overviewForm.store, (select) => select.values.Price);
  const Znacka = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.Znacka,
  );
  // const RokVyrobyOd = useStore(
  //   overviewForm.store,
  //   (select) => select.values.DetailCategoryFilter?.RokVyrobyOd,
  // );
  // const RokVyrobyDo = useStore(
  //   overviewForm.store,
  //   (select) => select.values.DetailCategoryFilter?.RokVyrobyDo,
  // );
  const RokUvedeniDoProvozuOd = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.RokUvedeniDoProvozuOd,
  );
  const RokUvedeniDoProvozuDo = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.RokUvedeniDoProvozuDo,
  );
  const Prevodovka = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.Prevodovka,
  );
  const NajetoDo = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.NajetoDo,
  );
  const Palivo = useStore(
    overviewForm.store,
    (select) => select.values.DetailCategoryFilter?.Palivo,
  );

  const activeFiltersArray: ActiveFiltersArrayProps[] = useMemo(
    () => [
      { filterKey: "AssetsCategoryId", value: AssetsCategoryId },
      { filterKey: "RegionId", value: RegionId },
      { filterKey: "Price", value: Price },
      { filterKey: "DetailCategoryFilter.Znacka", value: Znacka },
      // { filterKey: "DetailCategoryFilter.RokVyrobyOd", value: RokVyrobyOd },
      // { filterKey: "DetailCategoryFilter.RokVyrobyDo", value: RokVyrobyOd },
      { filterKey: "DetailCategoryFilter.RokUvedeniDoProvozuDo", value: RokUvedeniDoProvozuDo },
      { filterKey: "DetailCategoryFilter.RokUvedeniDoProvozuOd", value: RokUvedeniDoProvozuOd },
      { filterKey: "DetailCategoryFilter.Prevodovka", value: Prevodovka },
      { filterKey: "DetailCategoryFilter.NajetoDo", value: NajetoDo },
      { filterKey: "DetailCategoryFilter.Palivo", value: Palivo },
    ],
    [
      AssetsCategoryId,
      RegionId,
      Price,
      Znacka,
      // RokVyrobyOd,
      // RokVyrobyDo,
      RokUvedeniDoProvozuDo,
      RokUvedeniDoProvozuOd,
      Prevodovka,
      NajetoDo,
      Palivo,
    ],
  );

  const validFilters = activeFiltersArray.filter(
    (filterItem) =>
      filterItem.value !== undefined &&
      filterItem.value !== 0 &&
      filterItem.value !== "",
  );

  return (
    <overviewForm.Field name="AssetsCategoryId">
      {(fieldApi) => {
        const handleReset = () => {

          // simpler reset ???
          for( const filterItem of activeFiltersArray) {
            fieldApi.form.setFieldValue(filterItem.filterKey, "");
          }
          // for (const filterItem of validFilters) {
          //   fieldApi.form.resetField(filterItem.filterKey);
          // }

          onClickReset();
        };

        const handleSubmit = () => {
          onClickFiltrovat();
        };
        return (
          <Stack direction="row" width="100%" justifyContent="end" gap={1}>
            <Button
              disabled={validFilters.length === 0}
              variant="contained"
              color="secondary"
              onClick={handleReset}
            >
              Resetovat aktivní filtry
            </Button>
            <Button
              disabled={validFilters.length === 0}
              variant="contained"
              color="success"
              onClick={handleSubmit}
            >
              Filtrovat
            </Button>
          </Stack>
        );
      }}
    </overviewForm.Field>
  );
};
